<template>
  <section ref="targetDom" class="product_list_wrap">
    <nav :class="[classFixed ? 'fixed' : '', 'p_l_nav']">
      <span v-for="(item, index) in secondNav" :key="index" @click="clickSecondNavItem(item.ID, index)" :class="[currentIndex === index ? 'active' : '']" class="nav_btn">
        {{ item.ClassifyName }}
      </span>
    </nav>

    <section ref="initOst" :class="[classFixed ? 'padding' : '', 'product_exhibition']">
      <div class="floor-item">
        <p>{{ secondNavItem.ClassifyName }}</p>
        <ul>
          <li class="product-list-item" v-for="(item, index) in goodsList" :key="index" @click="showDetailPage(item)">
            <img v-if="item.GoodsLogoUrl != ''" :src="item.GoodsLogoUrl" alt="图片加载失败" />
            <img v-else src="../../assets/image/12.jpg" alt="大床房" />
            <div class="goods_info">
              <h3>{{ item.ScopeName }}</h3>
              <span>
                <i class="red-text iconfont icon-renminbi"></i>
                {{ item.AdultPrice }}
              </span>
              <span :class="['text_nowrap', '']">{{ item.Description }}</span>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ScopeMenuList',
  data() {
    return {
      currentIndex: 0,
      currentClassifyId: 0,
      currentGoodsId: 0,
      classFixed: false
    };
  },
  props: {
    secondNav: {
      type: Array
    },
    secondNavItem: {
      type: Object
    },
    goodsList: {
      type: Array
    }
  },
  methods: {
    clickSecondNavItem(itemId, index) {
      this.currentIndex = index;
      if (this.currentClassifyId != this.secondNav[index].ID) {
        this.currentClassifyId = this.secondNav[index].ID;
        this.$emit('changedScopeClassify', this.secondNav[index]);
      }
    },
    showDetailPage(item) {
      this.currentGoodsId = item.ID;
      this.$router.push({
        name: 'ScopeContent',
        params: {
          id: item.ID
        }
      });
    }
  }
};
</script>

<style>
.product_list_wrap {
  min-height: 60%;
  display: flex;
  justify-content: initial;
  align-items: initial;
  flex-wrap: initial;
  flex-direction: initial;
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  flex: 1;
  z-index: 10;
  color: #333;
  background-color: #e4e4e4;
}
.product_list_wrap .p_l_nav {
  width: 2rem;
  flex: 0 0 2rem;
}
.product_list_wrap .p_l_nav .nav_btn {
  width: 100%;
  /* text-overflow: clip; */
  /* white-space: nowrap; */
  text-align: center;
  font-size: 0.35rem;
  letter-spacing: 1px;
  display: block;
  line-height: 0.8rem;
  /* border-right: 1px solid #888; */
  /* border-radius: 5px; */
  border-bottom: 1px solid #eee;
  background-color: #fff;
  box-sizing: border-box;
  text-overflow: clip;
  overflow: hidden;
  padding: 0.5rem 0 0.5rem 6px;
}
.product_list_wrap .p_l_nav .active {
  background-color: #e4e4e4;
  color: #E77618;
  border-right: none;
  border-left: 4px solid #E77618;
}
.product_list_wrap .p_l_nav .active + .nav_btn {
  border-top-right-radius: 5px;
}

.product_list_wrap .product_exhibition {
  flex: 1;
  margin-top: 2px;
}
.product_list_wrap .product_exhibition .floor-item {
  padding: 5%;
  z-index: 1;
  /* margin: 0.3rem; */
  /* background-color: #fff; */
}
.product_list_wrap .product_exhibition .floor-item > p:first-child {
  background-color: #E77618;
  padding-left: 5px;
  color: #fff;
  font-weight: 600;
}
.product_list_wrap .product_exhibition .floor-item > ul {
  margin-top: 10px;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
  margin-top: 15px;
  background-color: #fff;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item > .goods_info {
  display: flex;
  justify-content: initial;
  align-items: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
  flex: 1;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item > .goods_info .iconfont {
  margin: 0 5px 0 0;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item h3 {
  text-align: right;
  color: #666;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.4);
  padding-right: 5px;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item span {
  max-width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
  white-space: nowrap;
}
.product_list_wrap .product_exhibition .floor-item > ul .product-list-item img {
  width: 1.6rem;
  max-width: 1.6rem;
  height: 1.6rem;
  /* padding: 0.16rem; */
  /* border: 1px solid #888; */
  text-align: center;
}
.padding {
  padding-left: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/child-components/ScopeMenuList.vue